import styled from 'styled-components';
import { useTranslations } from '../localisation/translateText';
import { OrderHelp } from '../orderHelp/OrderHelp';
import { translations, translationsType } from './translations';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;
  gap: 30px;
  box-sizing: border-box;
  text-align: center;
`;

export const OrderInfoErrorPage = (): JSX.Element => {
  const { translationsContent } = useTranslations<translationsType>(translations);
  return (
    <Wrapper>
      <div>{translationsContent.errorLoadingOrder}</div>
      <OrderHelp centered />
    </Wrapper>
  );
};
